<template>
  <div class="botao-switch">
    <div
      id="id1"
      :class="{ 'item-selecionado': itemSelecionado == 'id1' }"
      class="item primeiro-item"
      @click="processarClique">PJ x CLT</div>

    <div
      id="id2"
      :class="{ 'item-selecionado': itemSelecionado == 'id2' }"
      class="item"
      @click="processarClique">PJ x Autônomo</div>
  </div>
</template>

<script>
export default {
  name: "BotaoSwitch",
  data() {
    return {
      itemSelecionado: 'id1'
    }
  },
  props: {
    onClick: {
      type: Function,
      required: true
    }
  },
  methods: {
    processarClique: function (event) {
      let targetId = event.currentTarget.id;
      this.itemSelecionado = targetId;

      if (this.onClick && typeof this.onClick === 'function') {
        this.onClick(this.itemSelecionado);
      }
    }
  }
}
</script>

<style>
.botao-switch {
  max-width: 500px;
  margin: 0 auto 30px;
  justify-content: center;
  border-radius: 21px;
  background-color: #e8edf6;
  cursor: pointer;
  display: flex;
  padding: 0 !important;
}

.botao-switch .item {
  width: 50%;
  text-align: center;
  font-size: 16px;
  color: #7C92AB;
  background-color: transparent;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}

.botao-switch .item-selecionado {
  background-color: #1B53AD;
  color: #FFFFFF;
  font-weight: 700;
}
</style>